import type { ChangeEvent } from "preact/compat";
import { forwardRef } from "preact/compat";

export type ComboboxSearchInputProps = {
  handleSearchChange?: (term: string) => void;
  handleSearchBlur?: (term: string) => void;
  term?: string;
  rebrand?: boolean;
};

export const ComboboxSearchInput = forwardRef<HTMLInputElement, ComboboxSearchInputProps>(({
  handleSearchChange,
  handleSearchBlur,
  term,
  rebrand,
}, ref) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const term = event.currentTarget.value;
    handleSearchChange?.(term);
  };

  const handleBlur = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const term = target.value;
    // Only call blur handler if there's a value or if it's empty (to handle clearing)
    if (term !== undefined) {
      handleSearchBlur?.(term);
    }
  };

  return (
    <div className="combobox-listbox__search-input my-4 px-1">
      <div className="relative mb-2 flex h-12 fs-unmask">
        <div
          className="absolute flex items-center top-2 left-2 justify-center text-center text-sm text-neutral-500 h-8 w-8"
          aria-hidden="true"
        >
          {rebrand ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M11.7363 10.4001L8.92336 7.58723C9.55627 6.64959 9.88445 5.47753 9.72036 4.21172C9.41563 2.05514 7.65755 0.320508 5.52442 0.0392158C2.33644 -0.359282 -0.359282 2.33644 0.0392158 5.52442C0.320508 7.65755 2.05514 9.41563 4.21172 9.72036C5.47753 9.88445 6.64959 9.55627 7.61067 8.92336L10.4001 11.7363C10.7752 12.0879 11.3612 12.0879 11.7363 11.7363C12.0879 11.3612 12.0879 10.7752 11.7363 10.4001ZM1.86762 4.86807C1.86762 3.2272 3.20375 1.86762 4.86807 1.86762C6.50894 1.86762 7.86852 3.2272 7.86852 4.86807C7.86852 6.53238 6.50894 7.86852 4.86807 7.86852C3.20375 7.86852 1.86762 6.53238 1.86762 4.86807Z" fill="currentColor"/>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="-4 -3 32 32"
              strokeWidth="1"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
              />
            </svg>
          )}
        </div>

        <input
          ref={ref}
          className="appearance-none py-3 pl-12 text-base w-full rounded-md border-2 border-gt-lilac-dark bg-white"
          placeholder="Search"
          value={term}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
});
